//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DeleteSubmittingEntityModel extends ModelBase {
      static readonly $typeName = 'DeleteSubmittingEntityModel';
      public key: string;
      public name: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/DeleteSubmittingEntityModel.ts